module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/e24f2e736aa5213f3626ba49ced27c35.svg";